import { StandardEvents } from '@shopify/events';

(() => {
  const dock = document.querySelector('.sw-mobile-navigation');
  const badge = dock?.querySelector('[data-sw-cart-count]');
  const cartLink = dock?.querySelector('a[data-sw-nav-index="3"]');
  if (!dock || !badge || !cartLink || dock.dataset.swCartCountWired) return;
  dock.dataset.swCartCountWired = 'true';

  let currentCount = Number(dock.dataset.swCartCount);
  if (!Number.isSafeInteger(currentCount) || currentCount < 0) {
    currentCount = Number(badge.textContent.trim().replace('+', '')) || 0;
  }
  let eventVersion = 0;
  let fetchVersion = 0;
  let fallbackTimeout = null;
  const root = String(window.Shopify?.routes?.root || '/');
  const normalizedRoot = root.endsWith('/') ? root : root + '/';

  const renderCount = (value, animate = false) => {
    const count = Number(value);
    if (!Number.isSafeInteger(count) || count < 0) return;
    const changed = count !== currentCount;
    currentCount = count;
    dock.dataset.swCartCount = String(count);
    badge.hidden = count === 0;
    badge.textContent = count > 99 ? '99+' : String(count);
    badge.dataset.swOverflow = String(count > 99);
    cartLink.setAttribute('aria-label', 'السلة، ' + count + ' قطعة');
    if (changed && animate && count > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      badge.animate(
        [{ transform: 'scale(.82)' }, { transform: 'scale(1.15)' }, { transform: 'scale(1)' }],
        { duration: 250, easing: 'ease-out' }
      );
    }
  };

  const refreshFromShopify = async () => {
    const requestedAtEventVersion = eventVersion;
    const requestId = ++fetchVersion;
    try {
      const url = new URL(normalizedRoot + 'cart.js', window.location.origin);
      const response = await fetch(url, {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (requestId !== fetchVersion || requestedAtEventVersion !== eventVersion) return;
      renderCount(cart?.item_count, true);
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[sw-mobile-cart-count] Unable to refresh cart:', error);
    }
  };

  const scheduleRefresh = () => {
    if (fallbackTimeout !== null) clearTimeout(fallbackTimeout);
    fallbackTimeout = setTimeout(() => {
      fallbackTimeout = null;
      refreshFromShopify();
    }, 160);
  };

  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    const version = ++eventVersion;
    if (!event.promise || typeof event.promise.then !== 'function') {
      scheduleRefresh();
      return;
    }
    event.promise.then(({ cart }) => {
      if (version !== eventVersion) return;
      const total = cart?.totalQuantity;
      if (Number.isSafeInteger(total) && total >= 0) renderCount(total, true);
      else scheduleRefresh();
    }).catch(error => {
      if (version !== eventVersion) return;
      if (error?.name !== 'AbortError') scheduleRefresh();
    });
  });

  // Compatibility with legacy cart updates and Shopify theme editor re-renders.
  document.addEventListener('cart:update', scheduleRefresh);
  document.addEventListener('shopify:section:load', scheduleRefresh);
  window.addEventListener('pageshow', event => {
    if (event.persisted) refreshFromShopify();
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshFromShopify();
  });
  renderCount(Number(dock.dataset.swCartCount), false);
})();
